import { CircleDollarSign, WalletCards, Construction } from "lucide-react";

import { Summary } from "../../../../components/ui/Summary";
import { CrmPetDiagnosisController } from "../../../../services/controllers/crmPetDiagnosis";
import { useCrmPetDiagnosis } from "../../../../store/crmPetDiagnosis/useCrmPetDiagnosis";
import { formatCurrency } from "../helpers";
import { EmptyState } from "../components/EmptyState";
import { MetricCard } from "../components/MetricCard";
import { SectionCard } from "../components/SectionCard";
import { SectionError } from "../components/SectionError";

export function FinancialSummary() {
  const controller = CrmPetDiagnosisController();
  const kpis = useCrmPetDiagnosis((state) => state.data.overviewKpis);
  const loading = useCrmPetDiagnosis((state) => state.data.loading.overviewKpis);
  const error = useCrmPetDiagnosis((state) => state.data.errors.overviewKpis);
  const filters = useCrmPetDiagnosis((state) => state.data.filters.overview);

  const links = {
    crmRevenue: `/diagnosis/crm-pet?tab=results&resultsPeriod=${filters.period}&resultsFrom=${filters.from}&resultsTo=${filters.to}&resultsMinDays=${filters.minDays}&resultsStatus=FINISHED&resultsContacted=true`
  }

  return (
    <SectionCard
      title="Resultado financeiro"
      description="Valores atribuídos ao CRM Pet dentro das janelas de recuperação."
      icon={CircleDollarSign}
    >
      {error && (
        <SectionError
          message={error}
          onRetry={() => controller.retrySection("overviewKpis")}
        />
      )}
      {!error && !loading && !kpis && <EmptyState title="Sem resultado financeiro no período" />}
      {!error && (loading || kpis) && (
        <Summary.Root>
          <MetricCard
            id="crm-financial-finished-average"
            icon={Construction}
            value="Em breve"
            label="Receita total"
          />
          <MetricCard
            id="crm-financial-total"
            icon={WalletCards}
            value={formatCurrency(kpis?.totalRevenue)}
            label="Receita Crm"
            link={links.crmRevenue}
            loading={loading}
          />
          <MetricCard
            id="crm-financial-service"
            icon={Construction}
            value="Em breve"
            label="Recieta Assiantes"
          />
          <MetricCard
            id="crm-financial-product"
            icon={Construction}
            value="Em breve"
            label="Receita de produtos"
          />
          <MetricCard
            id="crm-financial-opportunity-average"
            icon={Construction}
            value="Em breve"
            label="Receita adicionais"
          />
        </Summary.Root>
      )}
    </SectionCard>
  );
}
